import type { TransactionType } from '@mogul/api-client';

import { transactionsApi } from '../api';

export const createTransaction = async (
  email: string | null,
  hash: string,
  t_type: TransactionType,
  network: string,
  listingId: number,
  signed?: string | undefined,
) => {
  try {
    await transactionsApi.createTransaction({
      email: email ?? undefined,
      network,
      hash,
      hashedMessage: signed,
      transactionType: t_type,
      listingId,
    });
  } catch (e) {
    window.Sentry?.captureException(e, {
      tags: {
        file: 'marketplace-notifications.ts',
        function: 'createTransaction',
      },
    });
  }
};
